module.exports = __webpack_public_path__ + "img/6.f13108f9.png";